var swiper = new Swiper(".js01 .swiper", {
  pagination: {
    el: ".js01 .swiper-pagination",
    clickable: true,
  },
});
var swiper = new Swiper(".js02 .swiper", {
  pagination: {
    el: ".js02 .swiper-pagination",
    clickable: true,
  },
});
var swiper = new Swiper(".js03 .swiper", {
  pagination: {
    el: ".js03 .swiper-pagination",
    clickable: true,
  },
});
var swiper = new Swiper(".js04 .swiper", {
  pagination: {
    el: ".js04 .swiper-pagination",
    clickable: true,
  },
});
var swiper = new Swiper(".js05 .swiper", {
  pagination: {
    el: ".js05 .swiper-pagination",
    clickable: true,
  },
});
var swiper = new Swiper(".js06 .swiper", {
  pagination: {
    el: ".js06 .swiper-pagination",
    clickable: true,
  },
});
var swiper = new Swiper(".js07 .swiper", {
  pagination: {
    el: ".js07 .swiper-pagination",
    clickable: true,
  },
});
var swiper = new Swiper(".js08 .swiper", {
  pagination: {
    el: ".js08 .swiper-pagination",
    clickable: true,
  },
});
var swiper = new Swiper(".js09 .swiper", {
  pagination: {
    el: ".js09 .swiper-pagination",
    clickable: true,
  },
});

$(function () {
  $('#store_area li a').click(function () {
    $('#store_prefbox').fadeIn();
    $('#storeunder').addClass('storeunder');
    $('.store_areabox').hide();
    $('#store_area li a').removeClass('active');
    $(this).addClass('active');
    $('.store_areabox').hide();
    $($(this).attr('href')).fadeIn();
    return false;
  });
});

$(function () {
  $('#store_areamodal li a').click(function () {
    $('#store_prefboxmodal').fadeIn();
    $('#storeundermodal').addClass('storeunder');
    $('.store_areaboxmodal').hide();
    $('#store_areamodal li a').removeClass('active');
    $(this).addClass('active');
    $('.store_areaboxmodal').hide();
    $($(this).attr('href')).fadeIn();
    return false;
  });
});

$(function () {
  $('#store_pref01 li a').click(function () {
    $('#store_pref01 li a').removeClass('active');
    $(this).addClass('active');
    $('.tabContent').hide();
    $($(this).attr('href')).fadeIn();
    return false;
  });
  $('#store_pref02 li a').click(function () {
    $('#store_pref02 li a').removeClass('active');
    $(this).addClass('active');
    $('.tabContent').hide();
    $($(this).attr('href')).fadeIn();
    return false;
  });
  $('#store_pref03 li a').click(function () {
    $('#store_pref03 li a').removeClass('active');
    $(this).addClass('active');
    $('.tabContent').hide();
    $($(this).attr('href')).fadeIn();
    return false;
  });
  $('#store_pref04 li a').click(function () {
    $('#store_pref04 li a').removeClass('active');
    $(this).addClass('active');
    $('.tabContent').hide();
    $($(this).attr('href')).fadeIn();
    return false;
  });
  $('#store_pref05 li a').click(function () {
    $('#store_pref05 li a').removeClass('active');
    $(this).addClass('active');
    $('.tabContent').hide();
    $($(this).attr('href')).fadeIn();
    return false;
  });
  $('#store_pref06 li a').click(function () {
    $('#store_pref06 li a').removeClass('active');
    $(this).addClass('active');
    $('.tabContent').hide();
    $($(this).attr('href')).fadeIn();
    return false;
  });
});